import { render, staticRenderFns } from "./LinkLogin.vue?vue&type=template&id=03108863&scoped=true&"
import script from "./LinkLogin.vue?vue&type=script&lang=js&"
export * from "./LinkLogin.vue?vue&type=script&lang=js&"
import style0 from "./LinkLogin.vue?vue&type=style&index=0&id=03108863&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03108863",
  null
  
)

export default component.exports